import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { UnreadMessages } from "../utils/UnreadMessages";
//import { invokeGetUnreadMessages } from "../utils/AwsInvoke";
import { Auth } from "aws-amplify";
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import "../css/SideNavBar.css";

var textInput = null;
var submit_label;

const AlertBadge = {
    position: "relative",
    left:"-14px",
    top:"-8px",
    color: "#fca3a3",
    fontSize: "18px"
}

// Src: https://github.com/trendmicro-frontend/react-sidenav
export default class SideNavBarMenu extends Component {

    constructor(props) {
        super(props);
        var globalAdminUserId = localStorage.getItem('globalAdminUserId'); //

        this.state = {
            expanded: false,
            sideNavIcon: this.setIcon(this.props),
            unReadMessages: false,
            globalAdminUserId: globalAdminUserId
        }
    }

    componentDidMount = async () => {
        // TMP SOLUTION: This timer is needed because if checkForUnreadMessages() is called
        // immediately, there's some sort of webpack signin error; research more when there's time

        // 12/24/18: temp remove because it is causing a webpack signout error at the initial load of the page
        this.startInitGetUnreadMessagesTimer();
    }

    componentDidUpdate = () => {

    }

    componentWillReceiveProps = async (nextProps) => {
        var unread_msgs = false;
        if(this.props.unReadMessages > 0)
            unread_msgs = true;

        this.setState({
            sideNavIcon: this.setIcon(nextProps),
            unReadMessages: unread_msgs,
        });
    }

    checkForUnreadMessages = async () => {
        //console.log(">>>>>>> 1. Sidenav - Check for Unread Msgs DB");
        var globalAdminUserId = this.state.globalAdminUserId;

        var msg_obj = await UnreadMessages(globalAdminUserId);

        var unReadMessages        = msg_obj.unReadMessages;
        var unReadMessageIdsArray = msg_obj.unReadMessageIdsArray;

        this.setState({
            unReadMessages: unReadMessages, // true | false
            unReadMessageIdsArray: unReadMessageIdsArray
        });
    }

    startInitGetUnreadMessagesTimer() {
        /* temp turn off while flying to Cabo
        console.log("BEGIN Sidenavbar Unread Messages timer");
        var timer = 30;
        var that = this;

        this.timer = setInterval(function(){
            timer--;
            //console.log("Navbar timer: " + timer);
            if(timer <= 0) {
            //    console.log("finish!");
                clearInterval(that.timer);
                that.checkForUnreadMessages();
            }
        }, 1000);*/
    }

    setIcon = (that) => {
        var tmp_url_str = that.location.pathname;
        var sub_str = tmp_url_str.match("/(.*)/");
        var section;

        if(sub_str != null) section = sub_str[1].substr(0, sub_str[1].indexOf('/'));

        if(section == "") section = sub_str[1]; // used for the message section, which has no '&'

        var tmp_icon_sel = "index"; // default home icon

        if(section === "exercise" || section === "exercise/listAll" || section === "exercise/details")
            tmp_icon_sel = "exercise/listAll/&";
        else if(section === "client" || section === "client/listAll" || section === "client/details" || section === "client/detail")
            tmp_icon_sel = "client/listAll/&";
        else if(section === "document" || section === "document/listAll" || section === "document/details" || section === "document/detail")
            tmp_icon_sel = "document/listAllDocuments/&/&";
        else if(section === "assessment" || section === "assessment/listAllAssessments/&" || section === "assessment/details" || section === "assessment/detail")
            tmp_icon_sel = "assessment/listAllAssessments/&/&";
        else if(section === "message" || section === "message/listAll")
            tmp_icon_sel = "message/listAll"; // & needed
        else if(section === "programs")
            tmp_icon_sel = "programs/list";
        else if(section === "report") {
            tmp_icon_sel = "report/reportDashboard"; // this must be same as root url
        } else if(section === "help")
            tmp_icon_sel = "help/";

        else if(section === "scheduler")
            tmp_icon_sel = "scheduler/";
        else if(section === "zoom")
            tmp_icon_sel = "zoom/";
        else if(section === "setting")
            tmp_icon_sel = "setting/";
        else if(section === "login")
            tmp_icon_sel = "login";

        return tmp_icon_sel;
    }

    closeSideNav = () => {
        this.setState({
            expanded: false
        })
    }

    handleLogout = event => {
        //console.log("0. Login page - logout ...");
        Auth.signOut();

        localStorage.setItem('globalAdminUserId', null); // reset global user id
        localStorage.setItem('trainer_company_id', null); // reset trainer's company id
        sessionStorage.setItem('company_id', null); // reset company id
        sessionStorage.setItem('trainer_company_id', null); // reset trainer's company id
        //this.props.userHasAuthenticated(false);
        this.props.resetGlobalIds();

        //globalCompanyId: this.props.companyId
        this.props.history.push("/"); // /login
    }

    changeMenu = (selected) => {
        //console.log("Check for unread messages from sidebar nav.");
        // temp comment out to see if this is what's causing the "__WEBPACK_IMPORTED_MODULE_4__sigV4Client" error
        // Reason: could be accessing the database and other pages of the site before the identity has been verified
        // this.checkForUnreadMessages();

        const to = '/' + selected;
        if (this.props.location.pathname !== to) {
            this.props.history.push(to);
        }
    }
    render() {
        var show_alert_badge = "none";

        if(this.state.unReadMessages) show_alert_badge =  "inline";

        return (
            <SideNav
                onSelect={(selected) => {
                    this.changeMenu(selected)
                }}

                onToggle = {(expanded) => {
                    this.setState({
                        expanded: expanded
                    })
                }}/* */

                expanded = {this.state.expanded}
                style={{position:"fixed"}}
            >

                    <SideNav.Toggle/>
                    <SideNav.Nav style={{fontFamily: "UnitedSansRgMd"}} selected={this.state.sideNavIcon} onClick={()=>this.closeSideNav()}>
                            <NavItem eventKey="index">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-dashboard sideNavBarIcon" style={{ fontSize: '1.7em' }}/>
                                </NavIcon>
                                <NavText>
                                    Dashboard
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="programs/list">
                                <NavIcon>
                                    <FontAwesomeIcon icon="paste" className="sideNavBarIcon" style={{ fontSize: '1.9em' }}/>
                                { /*}<span className="glyphicon glyphicon-file sideNavBarIcon" style={{ fontSize: '1.5em' }}/>*/ }
                                </NavIcon>
                                <NavText>
                                    Templates
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="exercise/listAll/&">
                                <NavIcon>
                                    <FontAwesomeIcon icon="dumbbell" className="sideNavBarIcon" style={{ fontSize: '1.7em' }}/>
                                    { /*}<span className="glyphicon glyphicon-list sideNavBarIcon" style={{ fontSize: '1.5em' }}/> */}
                                </NavIcon>
                                <NavText>
                                    Exercises
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="client/listAll/&">
                                <NavIcon>
                                    { /*}<FontAwesomeIcon icon="far fa-user" className="sideNavBarIcon" style={{ fontSize: '1.65em' }}/>*/ }
                                    <span className="glyphicon glyphicon-user sideNavBarIcon" style={{ fontSize: '1.6em' }}/>
                                </NavIcon>
                                <NavText>
                                    Members
                                </NavText>
                            </NavItem>
                            { /*}<NavItem eventKey="message/listAll">
                                <span style={{display: show_alert_badge}}>
                                    <span className="glyphicon glyphicon-asterisk" style={AlertBadge}/>
                                </span>
                                <NavIcon>
                                    <span className="glyphicon glyphicon-comment sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Messages
                                </NavText>
                            </NavItem>*/ }
                            <NavItem eventKey="assessment/listAllAssessments/&/&">
                                <NavIcon>
                                    <FontAwesomeIcon icon="notes-medical" className="sideNavBarIcon" style={{fontSize: '2em' }}/>
                                { /*<span className="glyphicon glyphicon-signal sideNavBarIcon" style={{ fontSize: '1.5em' }}/> */}
                                </NavIcon>
                                <NavText>
                                    Assessments
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="document/listAllDocuments/&/&">
                                <NavIcon>
                                    <FontAwesomeIcon icon="file-signature" className="sideNavBarIcon2" style={{ fontSize: '1.8em' }}/>
                                    { /*}<span className="glyphicon glyphicon-folder-open sideNavBarIcon" style={{ fontSize: '1.5em' }}/>*/ }
                                </NavIcon>
                                <NavText>
                                    Documents
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="report/reportDashboard">
                                <NavIcon>
                                    <FontAwesomeIcon icon="chart-area" className="sideNavBarIcon3" style={{ fontSize: '1.8em' }}/>
                                    { /*}<span className="glyphicon glyphicon-folder-open sideNavBarIcon" style={{ fontSize: '1.5em' }}/>*/ }
                                </NavIcon>
                                <NavText>
                                    Reports
                                </NavText>
                            </NavItem>
                            { /*<NavItem eventKey="home">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-usd sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Financials
                                </NavText>
                            </NavItem>
                            { /*}<NavItem eventKey="home">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-globe sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Marketplace
                                </NavText>
                            </NavItem>*/ }
                            <NavItem eventKey="zoom/">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-facetime-video sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Zoom Meeting
                                </NavText>
                            </NavItem>
                            { /*}<NavItem eventKey="scheduler/">
                                <NavIcon>
                                    <FontAwesomeIcon icon="calendar-alt" className="sideNavBarIcon" style={{ fontSize: '1.7em' }}/>
                                </NavIcon>
                                <NavText>
                                    Scheduler
                                </NavText>
                            </NavItem> */ }
                            <NavItem eventKey="setting/">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-cog sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Settings
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="help/">
                                <NavIcon>
                                    <span className="glyphicon glyphicon-question-sign sideNavBarIcon" style={{ fontSize: '1.5em' }}/>
                                </NavIcon>
                                <NavText>
                                    Help
                                </NavText>
                            </NavItem>
                            <NavItem eventKey="login" onClick={this.handleLogout}>
                                <NavIcon>
                                    <span className="glyphicon glyphicon-remove-circle sideNavBarIcon" style={{ fontSize: '1.7em' }}/>
                                </NavIcon>
                                <NavText>
                                    Logout
                                </NavText>
                            </NavItem>
                        </SideNav.Nav>
                        <div style={{textAlign:"center", fontSize:"11px",color:"white"}}>
                            v12.8.20
                        </div>
            </SideNav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SideNavBarMenu.js